import React from 'react';
import { OptionProps, components } from 'react-select';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

const INDENT_MULTIPLIER = 20;

export const MultiSelectListItem = (props: OptionProps<any>) => {
  return (
    <components.Option {...props}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          ml: props.data.level ? `${props.data.level * INDENT_MULTIPLIER}px` : 0,
          py: 0.25,
        }}
      >
        <Checkbox
          size="small"
          checked={props.isSelected}
          onChange={() => null}
          sx={{ p: 0.5 }}
        />
        <Typography variant="body2" sx={{ color: 'text.primary', userSelect: 'none' }}>
          {props.label}
        </Typography>
      </Box>
    </components.Option>
  );
};
